class FuelCarbonData {
    public fuelName = ""
    public fuelCode = ""
    public fuelConsumptionPerYear = 0
    public consumptionInTons = true
    public consumptionInTonsName: string = "MWh"
}

export default FuelCarbonData
